var _style, _path, _path2, _feBlend, _feBlend2, _feBlend3, _feBlend4, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonBlueSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 352 148",
    style: {
      enableBackground: "new 0 0 352 148"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#50AED4;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000058571928666354843420000000055244694024786335_);}\n\t.st3{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st4{filter:url(#Adobe_OpacityMaskFilter_00000068675371462614386990000018353214275702841759_);}\n\t\n\t\t.st5{mask:url(#SVGID_00000151534940251582637390000004502938820063658167_);fill:url(#SVGID_00000094587152133666890230000006919966919037488789_);}\n\t.st6{fill:url(#SVGID_00000095319535739602331610000015869496454887828617_);}\n\t.st7{filter:url(#Adobe_OpacityMaskFilter_00000096779628492231113200000006465786195747869362_);}\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_00000031178357572340748560000017810032648053140147_);}\n\t\n\t\t.st9{mask:url(#SVGID_00000176738019374259001130000015073009861779439518_);fill:url(#SVGID_00000107585876827480297220000000367827478370502589_);}\n\t.st10{fill:url(#SVGID_00000164506789178698217260000001815099219747235474_);}\n\t.st11{opacity:0.1;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "blue_x5F_button_00000132791837391490552490000010343447957270489761_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button_00000175291436381923573160000016336555301284604321_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284,144.9H68c-37.3,0-67.5-30.2-67.5-67.5v0C0.5,40.2,30.7,10,68,10H284c37.3,0,67.5,30.2,67.5,67.5v0 C351.5,114.7,321.3,144.9,284,144.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 176,
    y1: 138.0201,
    x2: 176,
    y2: 3.0768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50AED4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    style: {
      stopColor: "#62BDD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2FFEE"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284,138H68c-37.3,0-67.5-30.2-67.5-67.5v0C0.5,33.3,30.7,3.1,68,3.1H284c37.3,0,67.5,30.2,67.5,67.5v0 C351.5,107.8,321.3,138,284,138z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085951427339878542970000010204930790450875802_",
    gradientUnits: "userSpaceOnUse",
    x1: 176,
    y1: 138.0201,
    x2: 176,
    y2: 3.0768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50AED4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03161561,
    style: {
      stopColor: "#53B0D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3DDFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085951427339878542970000010204930790450875802_)"
    },
    d: "M284,10c33.4,0,60.6,27.2,60.6,60.6 c0,33.4-27.2,60.6-60.6,60.6H68c-33.4,0-60.6-27.2-60.6-60.6C7.4,37.2,34.6,10,68,10H284 M284,3.1H68C30.7,3.1,0.5,33.3,0.5,70.5 v0C0.5,107.8,30.7,138,68,138H284c37.3,0,67.5-30.2,67.5-67.5v0C351.5,33.3,321.3,3.1,284,3.1L284,3.1z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 97,
    y: 3.1,
    width: 158.1,
    height: 6.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 3.1,
    width: 158.1,
    height: 6.9,
    id: "SVGID_00000046319754926859521210000002864252255483515811_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000129927537052673531220000010495720076250551983_",
    filterUnits: "userSpaceOnUse",
    x: 97,
    y: 3.1,
    width: 158.1,
    height: 6.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 3.1,
    width: 158.1,
    height: 6.9,
    id: "SVGID_00000046319754926859521210000002864252255483515811_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000129927537052673531220000010495720076250551983_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173151607878644678370000009697946615417573561_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.9598,
    y1: 6.5283,
    x2: 255.0402,
    y2: 6.5283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8338,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 3.1,
    style: {
      mask: "url(#SVGID_00000046319754926859521210000002864252255483515811_)",
      fill: "url(#SVGID_00000173151607878644678370000009697946615417573561_)"
    },
    width: 158.1,
    height: 6.9
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128443127635288964480000011374942124045522866_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.9598,
    y1: 6.5283,
    x2: 255.0402,
    y2: 6.5283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBFFEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#BBFFEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBFFEA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 3.1,
    style: {
      fill: "url(#SVGID_00000128443127635288964480000011374942124045522866_)"
    },
    width: 158.1,
    height: 6.9
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000142141642016713236770000010354883984034314893_",
    filterUnits: "userSpaceOnUse",
    x: 72.3,
    y: 131.1,
    width: 207.3,
    height: 6.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 72.3,
    y: 131.1,
    width: 207.3,
    height: 6.9,
    id: "SVGID_00000046320431966299868910000010235455638689597573_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000142141642016713236770000010354883984034314893_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000158748723732875589050000016328272655205866430_",
    filterUnits: "userSpaceOnUse",
    x: 72.3,
    y: 131.1,
    width: 207.3,
    height: 6.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 72.3,
    y: 131.1,
    width: 207.3,
    height: 6.9,
    id: "SVGID_00000046320431966299868910000010235455638689597573_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000158748723732875589050000016328272655205866430_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130616029268189732040000017083320936830666683_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.343,
    y1: 134.5685,
    x2: 279.657,
    y2: 134.5685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8338,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 72.3,
    y: 131.1,
    style: {
      mask: "url(#SVGID_00000046320431966299868910000010235455638689597573_)",
      fill: "url(#SVGID_00000130616029268189732040000017083320936830666683_)"
    },
    width: 207.3,
    height: 6.9
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078046832776237995980000001486960666579553713_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.343,
    y1: 134.5685,
    x2: 279.657,
    y2: 134.5685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBFFEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#BBFFEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBFFEA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 72.3,
    y: 131.1,
    style: {
      fill: "url(#SVGID_00000078046832776237995980000001486960666579553713_)"
    },
    width: 207.3,
    height: 6.9
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M71.8,56.2h216.1c25.8,0,48.1,14.4,59.5,35.7c-11.4-24.1-33.7-40.6-59.5-40.6H71.8 c-25.7,0-48.1,16.4-59.5,40.6C23.7,70.7,46,56.2,71.8,56.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBlueSmall);
export default __webpack_public_path__ + "static/media/button-blue-small.e604cf33812d000c1dc664d8900dfb78.svg";
export { ForwardRef as ReactComponent };